import React from "react";
import { InlineMath } from "react-katex";
import FractionInput, { formatLatexPreview } from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function formatMath1(v) {
  return Number(v).toFixed(1);
}

function pickData() {
  for (let i = 0; i < 900; i += 1) {
    const aWhole = randInt(1, 9);
    const bWhole = randInt(0, 8);
    const aTenths = randInt(1, 8);
    const bTenths = randInt(aTenths + 1, 9); // wymusza pożyczanie

    const aUnits = aWhole * 10 + aTenths;
    const bUnits = bWhole * 10 + bTenths;
    if (aUnits <= bUnits) continue;

    return {
      aUnits,
      bUnits,
      resultUnits: aUnits - bUnits,
      a: aUnits / 10,
      b: bUnits / 10,
      result: (aUnits - bUnits) / 10,
    };
  }

  return { aUnits: 12, bUnits: 3, resultUnits: 9, a: 1.2, b: 0.3, result: 0.9 };
}

export function generateTask() {
  return {
    type: "DecimalSubtractionMemoryBorrowTask",
    data: pickData(),
  };
}

export function renderTask({ data }) {
  return (
    <div style={{ textAlign: "left" }}>
      <p>Oblicz w pamięci: <InlineMath math={`${formatMath1(data.a)} - ${formatMath1(data.b)}`} /></p>
    </div>
  );
}

export function renderInput(_task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="wynik"
      placeholder="np. 3,2 lub 3.2"
    />
  );
}

export function checkAnswer(task, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const parsed = userAnswer.parsed;
  if (parsed == null || !Number.isFinite(parsed)) return false;
  return Math.abs(parsed - task.data.result) < 1e-9;
}

export function renderAnswer({ data }) {
  return <InlineMath math={formatMath1(data.result).replace(".", "{,}")} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return <InlineMath math={formatLatexPreview(userAnswer.raw)} />;
}

export function renderExplanation({ data }) {
  const aWhole = Math.floor(data.aUnits / 10);
  const aTenths = data.aUnits % 10;
  const bWhole = Math.floor(data.bUnits / 10);
  const bTenths = data.bUnits % 10;

  const tenthsBorrowed = aTenths + 10;
  const tenths = tenthsBorrowed - bTenths;
  const whole = aWhole - 1 - bWhole;

  return (
    <div style={{ textAlign: "left" }}>
      <p>
        <strong>Krok 1:</strong> W części dziesiętnej nie możemy odjąć <InlineMath math={`${aTenths}-${bTenths}`} />,
        więc pożyczamy 1 z całości: <InlineMath math={`${aTenths}\\to${tenthsBorrowed}`} />.
      </p>
      <p>
        <strong>Krok 2:</strong> Dziesiętne: <InlineMath math={`${tenthsBorrowed}-${bTenths}=${tenths}`} />,
        a całości: <InlineMath math={`${aWhole}-1-${bWhole}=${whole}`} />.
      </p>
      <p>
        <strong>Wynik:</strong> <InlineMath math={`${whole}{,}${tenths}`} />.
      </p>
    </div>
  );
}

